// extracted by mini-css-extract-plugin
module.exports = {"inter_text_style":"BulkImportInformation_inter_text_style__2WLUw","inner_numeric_style":"BulkImportInformation_inner_numeric_style__1Izea"};